import React, { useEffect, useState } from "react";
import { Tree } from "antd";
import { connect } from "react-redux";
import AnalysisApi from "../../../api/analysis";
import DeviceHealth from "../../../components/deviceHealth";
import "./index.scss";

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(() => {
  const [treeData, setTreeData] = useState([]);
  const [deviceId, setDeviceId] = useState();
  const [expandedKeys, setExpandedKeys] = useState([]);

  useEffect(() => {
    getStations();
  }, []);

  const getStations = () => {
    AnalysisApi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        const list = res.data.map((item) => {
          return {
            ...item,
            title: item.aliasName,
            key: `${item.id}-station`,
            type: "station",
            pid: -1,
          };
        });
        setTreeData(list);
        if (list.length > 0) {
          setExpandedKeys([list[0].key]);
        }
      }
    });
  };

  const selectProcessUnitList = async (key) => {
    const res = await AnalysisApi.selectProcessUnitList(key.split("-")[0]);
    if (res.status == 0 && res.data) {
      const arr = res.data.map((item) => {
        return {
          ...item,
          title: item.name,
          key: `${item.id}-process`,
          pid: key,
          type: "process",
        };
      });
      return arr;
    }
    return [];
  };

  const selectDeviceList = async (key, stationId) => {
    const param = {
      pageNum: 1,
      pageSize: 9999,
      processUnitId: key.split("-")[0],
      stationId: stationId.split("-")[0],
    };
    const res = await AnalysisApi.selectDeviceList(param);
    const { data, status } = res;
    if (status == 0 && data.data) {
      const arr = data.data.map((item) => {
        return {
          ...item,
          title: item.deviceName,
          key: `${item.id}-device`,
          pid: key,
          type: "device",
        };
      });
      return arr;
    }
    return [];
  };

  const selectNextDeviceList = async (key) => {
    const param = {
      pageNum: 1,
      pageSize: 9999,
      devId: key.split("-")[0],
    };
    const res = await AnalysisApi.selectNextDeviceList(param);
    const { data, status } = res;
    if (status == 0 && data.data) {
      const arr = data.data.map((item) => {
        return {
          ...item,
          title: item.deviceName,
          key: `${item.id}-device4`,
          pid: key,
          type: "device",
          isLeaf: true,
        };
      });
      return arr;
    }
    return [];
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return {
          ...node,
          children,
        };
      }
      if (node.children) {
        return {
          ...node,
          children:
            node.children && updateTreeData(node.children, key, children),
        };
      }
      return node;
    });
  };

  const onLoadData = ({ key, pid, type, children }) =>
    new Promise(async (resolve) => {
      if (children) {
        resolve();
        return;
      }
      let arr = [];
      if (type == "station") {
        arr = await selectProcessUnitList(key);
      } else if (type == "process") {
        arr = await selectDeviceList(key, pid);
      } else if (type == "device") {
        arr = await selectNextDeviceList(key);
      }
      setTreeData((origin) => updateTreeData(origin, key, arr));
      resolve();
    });

  const onSelect = (selectedKeys, { node }) => {
    if (node.type == "device") {
      const key = node.key.split("-")[0];
      setDeviceId(key);
    }
  };

  return (
    <div className="assetsmana-list">
      <div className="dev-tree">
        <Tree
          expandedKeys={expandedKeys}
          showLine
          loadData={onLoadData}
          onSelect={onSelect}
          treeData={treeData}
          height={700}
          onExpand={(keys) => setExpandedKeys(keys)}
        />
      </div>
      <div className="dev-info">
        <DeviceHealth deviceId={deviceId} />
      </div>
    </div>
  );
});
